import {useNavigate} from 'react-router-dom';
import SerialList from "./SerialList";

function SerialsPanel(params) {
    const navigate = useNavigate();
    const onBackClicked = () => navigate('/');

    return (
        <div style={{ backgroundColor: '#f3f4f6', minHeight: '100vh', padding: '20px' }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <button
                        onClick={onBackClicked}
                        style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #d1d5db', backgroundColor: '#fff', cursor: 'pointer', fontWeight: '600' }}
                    >
                        ← Назад
                    </button>
                    <h2 style={{ margin: 0 }}>Керування релізами</h2>
                    <button
                        onClick={() => navigate('/serials/edit')}
                        style={{ padding: '8px 20px', borderRadius: '8px', border: 'none', backgroundColor: '#4f46e5', color: '#fff', cursor: 'pointer', fontWeight: '600' }}
                    >
                        + Додати аніме
                    </button>
                </div>
                <SerialList user={params.user}/>
            </div>
        </div>
    );
}

export default SerialsPanel;